import { useHasPermission } from "../../auth/useClaims";

// Vehicle Master (handoff §20.1) - standard page-wise Create/Edit/View
// triad (§13.3), no all-branch check (server already branch-scopes reads/
// writes the same way Customers/Products/Employees do). Vehicles.CreateRequest/
// .ApproveRequest/.ViewRequests/.ViewAllRequests exist in the catalog too but
// belong to the not-yet-built Maintenance Requests screen - no hooks for
// those here.
export const useCanCreateVehicles = () => useHasPermission("Vehicles.Create");
export const useCanEditVehicles = () => useHasPermission("Vehicles.Edit");
